<div class="container-fluid">
    <div class="row">
        <div class="modal-body" id="request_success_msg">
            <div class="row" id="success_style">
                <div class="col-12 p-3 zsd-cust-common-pageheading-font">{{ 'ReportIncident.confirmation' | translate }}
                    <span><em class="fas fa-times float-right" style="cursor: pointer;" (click)="cancelQuickCall()"
                            data-dismiss="modal"></em></span>
                </div>
                <div *ngIf="quickCallDetail.quickCallType === 'quickCall'" class="col-12 pt-0 pl-3 pr-3 pb-4">
                    {{ createdRequestResponse.requestId }} REQUEST CREATED SUCCESSFULLY
                </div>
                <div *ngIf="quickCallDetail.quickCallType === 'groupQuickCall'" class="col-12 pt-0 pl-3 pr-3 pb-4">
                    {{ this.requestNumbers.join(', ') }} REQUESTS CREATED SUCCESSFULLY
                </div>
            </div>
            <div *ngIf="createdRequestResponse.hasProposedSolution" class="row">
                <div class="col-12 p-3 zsd-cust-common-pageheading-font">
                    {{ 'ReportIncident.proposedsolutionfound' | translate }}
                </div>
                <div class="col-12 pt-0 pl-3 pr-3 pb-4">{{ 'ReportIncident.viewproposedsolutionmessage' | translate }}
                </div>
            </div>
            <div class="text-center" id="redirectbutton">
                <button type="button" *ngIf="createdRequestResponse.hasProposedSolution"
                    class="btn zsd-cust-filter-button mt-2" id="zsd_cust_button_create" data-dismiss="modal"
                    [routerLink]="[showProposedSolutionPage(createdRequestResponse.requestId)]">
                    {{ 'ReportIncident.viewproposedsolution' | translate }}
                </button>
                <button type="button" class="btn zsd-cust-filter-button mt-2" id="zsd_cust_button_cancel"
                    data-dismiss="modal" [routerLink]="['/requests']">
                    {{ 'ReportIncident.redirecttorequestpage' | translate }}
                </button>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="quick_call_row">
            <form (ngSubmit)="createRequest()" [formGroup]="quickCallForm">
                <div *ngIf="serverError!=null" class="alert alert-danger mt-3" [innerHTML]="serverError">
                </div>
                <!-- start of quick call -->
                <div *ngIf="quickCallDetail.quickCallType === 'quickCall'">
                    <div *ngIf="quickCallDetail.itemSpecified" class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label for="item" id="sd_item_id_label">
                                {{ 'QuickCallDetail.itemName' | translate }}
                                <span *ngIf="itemSelectionRequired && !quickCallDetail.itemSpecified"
                                    id="mandatory_field">&#42;</span>
                            </label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ quickCallDetail.itemInfo.itemIdentifier }}</div>
                    </div>

                    <div *ngIf="!quickCallDetail.itemSpecified" class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label for="item" id="sd_item_id_label">
                                {{ 'ItemSelection.itemSearch' | translate }}
                            </label>
                        </div>
                        <div id="quickCallItemSearch"
                            class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                            <input class="form-control" id="sd_item_search_name" type="text"
                                placeholder="{{ 'ItemSelection.searchItem' | translate }}" formControlName="item"
                                (keyup)="searchItem($event)" [(ngModel)]="itemSearchTerm" autocomplete="off" (keydown)="itemSearchListKeyPressAction($event)">
                            <div *ngIf="itemSearchTerm.length > 1 && showdropDownList" class="searchList">
                                <a [attr.id]="'searchitem' + i" class="dropdown-item pl-2 pr-2" [ngClass]="{'active-element-in-list': i === currentSearchItemIndex}" *ngFor="let item of itemResultFromSearch; let i = index"
                                     data-toggle="tooltip" data-placement="left"
                                    title={{item.itemName}} (click)="setItem(item);"> {{item.itemName}}
                                    <span id="quickCallIdentifierSearch">{{item.itemIdentifier.substring(item.itemName.length, item.itemIdentifier.length)}}</span>
                                </a>
                            </div>
                            <div class="validation-error-inline text-danger" *ngIf="flagItemNotFound else elseBlock">{{ 'ItemSelection.noItemsFound' | translate }}</div>
                            <ng-template #elseBlock>
                                <div class="validation-error-inline text-danger"
                                    *ngIf="(itemSelectionRequired) && 
                                        (quickCallForm.controls['item'].touched && selectedName === defaultItemNameString)">
                                    {{ 'ItemSelection.selectItemValidationMessage' | translate }}
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div *ngIf="!quickCallDetail.itemSpecified && selectedName !== defaultItemNameString"
                        class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label for="item" id="sd_item_id_label">
                                {{ 'QuickCallDetail.itemName' | translate }}
                                <span *ngIf="itemSelectionRequired && !quickCallDetail.itemSpecified"
                                    id="mandatory_field">&#42;</span>
                            </label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                            {{ itemIdentifier }}
                        </div>
                    </div>
                    <div *ngIf="quickCallDetail.itemSpecified || selectedName !== defaultItemNameString">
                        <div class="row mt-3 pl-3">
                            <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                                <label id="sd_item_type_label">
                                    {{'QuickCallDetail.itemType'| translate}}
                                </label>
                            </div>
                            <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                                {{ itemTypeName }}</div>
                        </div>

                        <div class="row mt-3 pl-3">
                            <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                                <label for="classification" id="sd_classification_label">
                                    {{ 'QuickCallDetail.classification' | translate }}
                                </label>
                            </div>
                            <div *ngIf="quickCallDetail.itemSpecified"
                                class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                                {{ classificationName }}</div>
                            <div *ngIf="!quickCallDetail.itemSpecified"
                                class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                                <select class="form-control custom-select" id="sd_classification"
                                    formControlName="classification" #t [(ngModel)]="selectedClassification">
                                    <option
                                        *ngFor="let classification of classificationOptions;trackBy:trackByTypeOptions"
                                        [value]="classification.classificationId">
                                        {{ classification.classificationName }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div *ngIf="showStatus" class="row mt-3 pl-3">
                            <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                                <label id="sd_item_status_label">
                                    {{'QuickCallDetail.status'| translate}}
                                </label>
                            </div>
                            <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ statusName }}
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label id="sd_priority_label">
                                {{'QuickCallDetail.priority'| translate}}
                            </label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ priorityName }}
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                        <zsd-customfields [parentForm]="quickCallForm" [customFields]="customFields"
                            [fromQuickCall]=true [id]="null">
                        </zsd-customfields>
                    </div>
                    <div *ngIf="quickCallDetail.containCustomForm"
                        class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                        <zsd-formio #formio [parentForm]='quickCallForm' [formSchema]='formSchema' 
                        [fromStoreItem]=false></zsd-formio>
                    </div>

                    <div *ngIf="showSubject" class="row mt-3 pl-3" id="sd_quickcall_subject_field">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label for="subject" id="sd_incident_subject_label">
                                {{ 'QuickCallDetail.requestSubject' | translate }}
                                <span *ngIf="subjectRequired" id="mandatory_field">&#42;</span>
                            </label>
                            <br />
                        </div>
                        <div class="sd-qc-item-detail col-sm-8 col-md-8 col-lg-10 col-xl-10 col-12">
                            <div>
                                <input class="form-control" id="sd_incident_subject" type="text" name="subject"
                                    [(ngModel)]="subject" formControlName="subject" (focus)="subjectFieldFocus = true"
                                    (blur)="subjectFieldFocus = false" [ngClass]="{'error-class':subjectRequired && quickCallForm.controls['subject'].touched
                                                    && !subjectFieldFocus && subjectEmpty()}" maxlength="255"
                                    autocomplete="off">
                            </div>
                            <div *ngIf="subjectRequired && quickCallForm.controls['subject'].touched 
                                                && !subjectFieldFocus && subjectEmpty()"
                                class="validation-error-inline text-danger">
                                {{ 'ReportIncident.subjectValueRequiredError' | translate }}
                            </div>
                        </div>

                    </div>
                </div>
                <!-- End of quick call and start of group -->
                <div *ngIf="quickCallDetail.quickCallType === 'groupQuickCall'">
                    <div class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label id="sd_item_type_label">{{'QuickCallDetail.itemType'| translate}}</label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ itemTypeName }}
                        </div>
                    </div>
                    <div class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label for="classification"
                                id="sd_classification_label">{{ 'QuickCallDetail.classification'| translate }}</label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">
                            {{ classificationName }}</div>
                    </div>
                    <div class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label id="sd_item_status_label">{{'QuickCallDetail.status'| translate}}</label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ statusName }}
                        </div>
                    </div>
                    <div class="row mt-3 pl-3">
                        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-12">
                            <label id="sd_priority_label">{{'QuickCallDetail.priority'| translate}}</label>
                        </div>
                        <div class="sd-qc-item-detail col-sm-12 col-md-7 col-lg-3 col-xl-3 col-12">{{ priorityName }}
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                        <zsd-customfields [parentForm]="quickCallForm" [customFields]="customFields"
                            [fromQuickCall]=true [id]="null">
                        </zsd-customfields>
                    </div>

                    <!-- start of group quick call table -->

                    <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-4 pb-3">
                        <div class="row">
                            <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                                <label>{{'QuickCallDetail.quickcalltableheader'| translate}}
                                    <span *ngIf="oneQuickcallSelected" class="select-quick-call">
                                        <span id="mandatory_field">&#42;</span>
                                        {{'QuickCallDetail.selectonequickcall' | translate}}
                                    </span>
                                </label>
                            </div>
                            <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                                <div class="c-quick_call_list table-responsive">
                                    <table class="table" id="c_quick_call_table">
                                        <thead>
                                            <tr id="c_quick_call_table_header">
                                                <th scope="col" > </th>
                                                <th scope="col" > {{'QuickCallDetail.template'| translate}}</th>
                                                <th scope="col" > {{'QuickCallDetail.tableitem'| translate}}</th>
                                                <th scope="col" *ngIf="showStatus"> {{'QuickCallDetail.tablestatus'| translate}}
                                                </th>
                                                <th scope="col" > {{'QuickCallDetail.tablepriority'| translate}}</th>
                                                <th scope="col" >{{'QuickCallDetail.tableclassification'| translate}}</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let quickCall of quickCallListForGroup;let i=index;"
                                            [attr.id]="'table_body' + quickCall.id">
                                            <tr class="{{ quickCall.containCustom || quickCall.containCustomForm ? 'expand collapsed' : 'no_expand'}}"
                                                data-toggle="collapse" [attr.id]="'qc_custom_field' + i"
                                                [attr.data-target]="'#qc_custom_field_target' + i" (click)="onClick(i)">
                                                <td style="min-width: 4rem">
                                                    <span *ngIf="quickCall.isMandatoryCustomField"
                                                        id="field_required"></span>&nbsp;
                                                    <span *ngIf="!quickCall.isMandatoryCustomField"
                                                        style="margin-right:3px;"></span>
                                                    <span *ngIf="quickCallDetail.groupComponentsSelection">
                                                        <input type="checkbox" class="qc_form_check_input"
                                                            (click)="selectQuickCall(quickCall, $event)" checked="true">
                                                    </span>
                                                    <span *ngIf="quickCall.containCustom || quickCall.containCustomForm"
                                                        [attr.id]="'plusicon' + i"
                                                        class="fa fa-plus-square fa-lg icon_custom"></span>
                                                    <span
                                                        *ngIf="!quickCall.containCustom && !quickCall.containCustomForm"
                                                        style="margin-right:13px"></span>
                                                </td>
                                                <td>
                                                    {{quickCall.name}}
                                                </td>
                                                <td> {{quickCall.itemInfo.itemName}}</td>
                                                <td *ngIf="showStatus"> {{quickCall.itemInfo.statusName}}</td>
                                                <td> {{quickCall.priority.displayName}}</td>
                                                <td> {{quickCall.classification.classificationName}}</td>
                                            </tr>
                                            <tr *ngIf="quickCall.containCustom || quickCall.containCustomForm"
                                                [attr.id]="'qc_custom_field_target' + i" class="collapse">
                                                <td colSpan="5">
                                                    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                                                        <zsd-quickcallfields #formioGroup [parentForm]="quickCallForm"
                                                            [customFields]="quickCall.customFieldInfo"
                                                            [quickCall]="quickCall" [id]="quickCall.id"
                                                            [formSchema]="(quickCall.parsedFormData) ? quickCall.parsedFormData : null">
                                                        </zsd-quickcallfields>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style="margin-top: 5px;">{{'QuickCallDetail.noteFirst' | translate}} <span
                                        id="field_required" style="vertical-align: text-bottom;"></span>
                                    &nbsp;{{'QuickCallDetail.noteLast' | translate}}</div>
                            </div>

                        </div>
                    </div>

                    <!-- end of group -->
                </div>
                <!--Ticket Description-->
                <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-3">
                    <div class="row">
                        <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                            <label for="ticketDescription"
                                id="sd_ticket_desc">{{ 'ReportIncident.ticketDescription' | translate }}
                                <span id="mandatory_field">&#42;</span>
                            </label>
                        </div>
                        <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                            <zsd-tinymce [parentForm]="quickCallForm" [required]=true
                                [tinymceData]="quickCallDetail.description"
                                [requiredError]="'QuickCallDetail.descriptionRequired' | translate">
                            </zsd-tinymce>
                        </div>
                    </div>
                </div>

                <!-- File Upload Component -->
                <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-3">
                    <div class="row">
                        <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                            <label for="attachment">{{ 'ReportIncident.attachment' | translate }}</label>
                        </div>
                        <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12" id="attachment_upload">
                            <zsd-fileupload (isformValid)="isfileuploadformvalid($event)"
                                (filesSelected)="selectedFilesList($event)"></zsd-fileupload>
                        </div>
                    </div>
                </div>

                <div id="zsd_button_separation_line"></div>
                <!--Create & Cancel Button-->
                <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <div class="row">
                        <div class="col-lg-5 col-md-5 col-xl-5">&nbsp;</div>
                        <div class="col-lg-2 col-md-1 col-xl-2 col-sm-12 col-12" id="sd_reportincident_spinner">
                            <div *ngIf="loading" id="spinner" role="progressbar">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-6 col-xl-5 col-sm-12 col-12">
                            <div class="form-group float-right">
                                <button type="submit" class="btn zsd_button" id="zsd_cust_button_create"
                                    (click)="callFormioSubmitButton()">
                                    {{ 'QuickCallDetail.createButton' | translate }}
                                </button>
                                <button type="button" class="btn zsd_button" id="zsd_cust_button_cancel"
                                    data-dismiss="modal" (click)="cancelQuickCall()">
                                    {{ 'QuickCallDetail.cancelButton' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>